<div class="container" fxLayout="column" fxLayoutAlign="start center">
    <div class='w-100-p back-button' (click)="goBack()">
        <mat-icon>{{ settingsBackArrowIcon }}</mat-icon>
    </div>
    <div class="sections" fxLayout="column" fxLayoutGap="12px">

        <div class="profile-container" fxLayout="column" fxLayoutAlign="start center">
            <div class="avatar">
                <img src="{{environment.uriG}}/image/small/{{ _userState.currentUser().image }}" alt="Profil Image" class="notif-profil-image">
            </div>
            <div class="title-small">
                {{this._userState.currentUser().nom}} {{this._userState.currentUser().prenom}}
            </div>
            <div class="account-route label-medium" (click)="navigateTo('/administration/compte')">{{ 'settings.myAccount' | transloco }}</div>
        </div>
        <div (click)="toggleSidebarOpen('quickPanel')" class="notification-container" fxLayout="row" fxLayoutAlign="space-between center" class="aep-card">
            <div fxLayout="row" fxLayoutAlign="center start" fxLayoutGap="16px">
                <mat-icon>notifications</mat-icon>
                <div>
                <div class="title-medium">{{ 'settings.notifications' | transloco }}</div>
                    <div class="body-small">
                        @if (_notificationState.notificationCount() > 0) {
                            <span class="bold">{{ 'settingsExtra.unreadNotifications' | transloco:{count: _notificationState.notificationCount()} }}</span>
                        } @else {
                            <span class="bold">{{ 'settings.noNotifications' | transloco }}</span>
                        }
                        
                    </div>
                </div>
            </div>
            <mat-icon>{{ settingsRowArrowIcon }}</mat-icon>
        </div>
        <div *accessControl="{ permissions: administrationPermissions['view-solde-facturation']}" class="notification-container" fxLayout="row" fxLayoutAlign="space-between center" class="aep-card">
            <div class="title-medium">{{ 'settings.balance' | transloco }} : {{billingState.balance() | number:'1.0-3'}} {{ 'settingsExtra.currency' | transloco }}</div>
            <button mat-flat-button class="btn-width" (click)="navigateTo('/administration/payment/fixed')">
                <mat-icon>
                    add
                </mat-icon>
                {{ 'settings.recharge' | transloco }}
            </button>
        </div>
        

        <div *ngIf="upgrade" class="notification-container" fxLayout="row" fxLayoutAlign="space-between center" class="aep-card">
            <div class="title-medium">{{ 'settingsAudit.upgrade' | transloco }}</div>
            <button mat-flat-button class="btn-width" (click)="navigateTo('/administration/payment-choice',{upgrade: true})">
                <mat-icon>
                    <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px"
                        fill="#FFFFFF">
                        <path
                            d="m241-547 78 26q15-28 31-54.5t34-52.5l-55-7-88 88Zm138 65 102 102q48-25 91-54.5t81-67.5q60-60 99.5-133T792-792q-85 0-158 39t-133 99q-38 38-68 81t-54 91Zm170-67q-21-21-21-51t21-51q21-21 51-21t51 21q21 21 21 51t-21 51q-21 21-51 21t-51-21Zm-2 308 88-88-7-55q-26 18-52.5 34T521-319l26 78Zm307-614q26 102-18.5 210T710-456l-8 8.5-8 8.5 12 101q2 17-3.5 32.5T685-278L515-108l-68-203-135-136-204-68 170-171q12-12 27.5-17.5T338-707l101 13 9.5-9 9.5-9q81-81 187.5-125.5T854-855ZM178-331q32-30 75.5-29.5T329-328q30 30 30.5 72.5T332-181q-43 49-107.5 61.5T96-96q11-63 23-126.5T178-331Zm45 57q-17 17-22.5 40T188-188q23-6 45.5-12t38.5-23q11-12 13.5-28t-8.5-27q-11-11-26.5-9T223-274Z" />
                    </svg>
                </mat-icon>
                améliorer
            </button>
        </div>

        <div class="notification-container" fxLayout="row" fxLayoutAlign="space-between center" class="aep-card">
            <div class="title-medium">{{ 'settings.inviteEarn' | transloco }}</div>
            <button mat-flat-button class="btn-width" (click)="openBottomSheet(InvitationItems, true)">
                <mat-icon>
                    group_add
                </mat-icon>
                {{ 'settings.invite' | transloco }}
            </button>
        </div>

        @if (_shareActionService.webpageurl) {
            <div *accessControl="{ permissions: onlineServicePermissions['view-web-page']}" class="notification-container" fxLayout="row" fxLayoutAlign="space-between center" class="aep-card">
                <div class="title-medium">{{ 'settings.webPage' | transloco }}</div>
                <button (click)="openBottomSheet(webPageSharingItems, true, 'web-page')" mat-flat-button class="btn-width">
                    <mat-icon>
                        share
                    </mat-icon>
                    {{ 'share.title' | transloco }}
                </button>
            </div>
        } @else {
            @if (webPageRequestMade){
                <div class="aep-success-card">
                    {{ 'settingsExtra.webPageRequestSuccess' | transloco }}
                </div>
            } @else {
                <button *accessControl="{ permissions: onlineServicePermissions['view-web-page']}" (click)="webPageRequestMade = true" mat-flat-button class="w-100-p">
                    <mat-icon>
                        web
                    </mat-icon>
                    {{ 'settingsExtra.requestWebPage' | transloco }}
                </button>
            }
        }
        <div class="group-container" fxLayout="column" fxLayoutAlign="start stretch">
            <div class="title-medium px-16 pb-16 header">
                {{ settingsItems['schoolItems'].title | transloco}}
            </div>
            <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="16px" class="aep-card">
                @for (item of settingsItems['schoolItems'].items; track $index) {
                    @if (item?.accessTypes && item?.accessTypes.includes(accessType)) {
                        <div  *accessControl="{ permissions: item?.permissions}"  (click)="handleNavigationOrDialog(item)" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px">
                            <div class="icon-label-container" fxLayout="row" fxLayoutAlign="center center">
                                <mat-icon [svgIcon]="'mat_outline:' + item.icon"></mat-icon>
                                <div>
                                    <div class="title-medium">{{ item.textKey ? (item.textKey | transloco) : item.text }}</div>
                                    @if (item.subtitleKey) {
                                        <div class="body-small">{{ item.subtitleKey | transloco }}</div>
                                    }
                                </div>
                            </div>
                            @if (loadingItems.has(item?.params) && item.action === 'route') {
                                <mat-spinner [diameter]="24"></mat-spinner>
                            } @else {
                                <mat-icon class="clickable">{{ settingsRowArrowIcon }}</mat-icon>
                            }
                        </div>
                        @if ($index < settingsItems['schoolItems'].items.length - 1) {
                            <span *accessControl="{ permissions: item?.permissions}">
                                <mat-divider></mat-divider>
                            </span>
                        }
                    }
                }
                
            </div>


        </div>
        <div class="group-container" fxLayout="column" fxLayoutAlign="start stretch">
            <div class="title-medium px-16 pb-16 header">
                {{ settingsItems['ParameterItems'].title | transloco}}
            </div>
            <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="16px" class="aep-card">
                @for (item of settingsItems['ParameterItems'].items; track $index) {
                    @if (item?.accessTypes && item?.accessTypes.includes(accessType)) {
                        <div *accessControl="{ permissions: item?.permissions}" (click)="handleNavigationOrDialog(item)" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px">
                            <div class="icon-label-container" fxLayout="row" fxLayoutAlign="center center">
                                <mat-icon [svgIcon]="'mat_outline:' + item.icon"></mat-icon>
                                <div class="title-medium">{{ item.textKey ? (item.textKey | transloco) : item.text }}</div>
                            </div>
                            @if (loadingItems.has(item.params) && item.action === 'route') {
                                <mat-spinner [diameter]="24"></mat-spinner>
                            } @else {
                                <mat-icon class="clickable">{{ settingsRowArrowIcon }}</mat-icon>
                            }
                        </div>
                        @if ($index < settingsItems['ParameterItems'].items.length - 1) {
                            <span *accessControl="{ permissions: item?.permissions}">
                                <mat-divider></mat-divider>
                            </span>
                        }
                    }
                }
            </div>
        </div>
        <div class="group-container" fxLayout="column" fxLayoutAlign="start stretch">
            <div class="title-medium px-16 pb-16 header">
                {{ 'settingsExtra.help' | transloco}}
            </div>
            <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="16px" class="aep-card">
                @for (item of settingsItems['HelpItems'].items; track $index) {
                    <div (click)="handleNavigationOrDialog(item)" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px">
                        <div fxLayout="row" fxLayoutAlign="center start" fxLayoutGap="16px">
                            <mat-icon [svgIcon]="'mat_outline:' + item.icon"></mat-icon>
                            <div class="title-medium">{{ item.textKey ? (item.textKey | transloco) : item.text }}</div>
                        </div>
                        @if (loadingItems.has(item.params) && item.action === 'route') {
                            <mat-spinner [diameter]="24"></mat-spinner>
                        } @else {
                            <mat-icon class="clickable">{{ settingsRowArrowIcon }}</mat-icon>
                        }
                    </div>
                    @if ($index < settingsItems['HelpItems'].items.length - 1) {
                        <mat-divider></mat-divider>
                    }
                }
            </div>
        </div>
        <div (click)="logout()" class="title-small logout" style="text-align: center;">
            {{ 'settingsExtra.logout' | transloco }}
        </div>
    </div>
</div>
